import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import { StandardButton } from "../../../../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    dialogText: {
        padding: "0 2rem",
    },
    dialogContent: {
        paddingBottom: "3rem",
    },
}))

type MeetingServiceTimeErrorDialogProps = Readonly<{
    show: boolean
    times: string[]
    handleDialogClose: () => void
}>

export function MeetingServiceTimeErrorDialog({ show, times, handleDialogClose }: MeetingServiceTimeErrorDialogProps) {
    const { classes } = useStyles()

    const isOneTimeItem = times.length === 1

    return (
        <StandardDialog
            open={show}
            onClose={handleDialogClose}
            dialogTitle={
                <LocalizedStrict id="create-order-order-summary-meeting-services-invalid-time-card-empty-title">
                    <>Delivery without items</>
                </LocalizedStrict>
            }
        >
            <Stack alignItems="center" gap="2rem" className={classes.dialogContent}>
                <LocalizedStrict
                    id={
                        isOneTimeItem
                            ? "create-order-order-summary-meeting-services-invalid-time-card-empty"
                            : "create-order-order-summary-meeting-services-invalid-times-card-empty"
                    }
                    vars={{ time: isOneTimeItem ? times[0] : times.join(", ") }}
                >
                    <Typography variant="body1" textAlign="center" className={classes.dialogText}>
                        The carts for the delivery times {times.join(", ")} are empty. Please add at least one product
                        to each time slot.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="create-order-order-summary-meeting-services-invalid-times-card-empty-button">
                    <StandardButton onClick={handleDialogClose} fullWidth={false} size="small">
                        Ok
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </StandardDialog>
    )
}
